import axios from 'axios';
import config from './config/domainconfig.json';

class Api {
  static client = null;
  constructor() {
    Api.client = null;
    let hostname = window.location.hostname;
    // const testHostname = "claysites.herokuapp.com";// Set this to test a URL like stage or live (on localhost only)
    // const testHostname = "stageacademy.localhost.com";
    // const testHostname = "nl.townmaking.com";
    // const testHostname = "www.townmaking.in";
    const testHostname = "www.townmaking.com";
    // const testHostname = "www.bfln.org";
    // const testHostname = "digitalsociety.townmaking.com";
    // const testHostname = "www.town-industries.com";
    // const testHostname = "www.embodiedmaking.com";
    // const testHostname = "www.product-foundry.com";
    // const testHostname = "academy.townmaking.com"
    if (hostname.indexOf("localhost") > -1 || (hostname.indexOf("192.") > -1) || hostname.indexOf("claysites.herokuapp") > -1) {
      if (testHostname) hostname = testHostname;
    }

    // ***** Getting domain and subdomain *** //
    const parts = hostname.split(".");
    this.domain = parts[1];
    this.subdomain = parts[0];
    this.tld = parts[2] || "com"
    // ***** Getting domain and subdomain *** //


    // ***** Getting env *** //
    const env = config[this.domain + "." + this.tld];
    if (!env) {
      throw new Error(("No config available for " + hostname));
    }
    if (this.subdomain && this.subdomain !== '' && env[this.subdomain]) {
      // env for subdomains
      this.env = Object.assign(env, env[this.subdomain]);
    } else {
      this.env = env;
    }
    this.organization = this.env.organization;
    // ***** Getting env *** //

    axios.interceptors.response.use(
      config => config,
      (error) => {
        if (error.response.status === 408 || error.code === 'ECONNABORTED') {
          this.touch({
            contactMethod: {
              type: "Email",
              data: {
                emailAddress: "aruna@product-foundry.com"
              }
            }, "requestMessage": { error: error, config: config }
          })
        }
        return Promise.reject(error);
      },
    );

  }

  getEnv() {
    return this.env;
  }

  getDomain() {
    return this.domain;
  }

  getSubdomain() {
    return this.subdomain;
  }

  getTld() {
    return this.tld;
  }

  getLangCode() {
    return this.env.langCode || 'en';
  }

  init = ( noCookies = false) => {


    let headers = {
      Accept: "application/json",
      tenant: "clay"
    };

    // if (api_token) {
    //   headers.Authorization = `Bearer ${api_token}`;
    // }

    Api.client = axios.create({
      withCredentials: noCookies ? false : true,
      baseURL: this.env.baseUrl,
      timeout: 31000,
      headers: headers,
    });
    return Api.client;

  };

  getExhibitConfig = () => {
    let url = window.location.origin;
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      url = "http://localhost:5000";
    }
    return axios.create({
      baseURL: url,
    }).get("/config.json");
  }

  getExhibits = () => {
    return Api.client.get("/content/" + this.env.organization + "/menu?sd=" + this.subdomain).then(res => {
      res.data.menus = res.data.menus.map(m => {
        m.orgId = this.env.organization;
        return m
      });
      return res;
    });
  };

  getResource = (eId, resourceUri, qualifier = "thumbnail") => {
    return Api.client.get(`/exhibitions/${eId}/resources/${resourceUri}?qualifier=${qualifier}`, { responseType: "blob" });
  }

  getPdfResource = (eId, resourceUri) => {

    let headers = {
      Accept: "*/*",
      tenant: "clay"
    };

    const client = axios.create({
      withCredentials: true,
      baseURL: this.env.baseUrl,
      timeout: 31000,
      headers: headers,
    });

    return client.get(`/exhibitions/${eId}/resources/${resourceUri}`, { responseType: "blob" });
  }

  getSisterExhibits = (org) => {
    return Api.client.get("/content/" + org + "/menu?sd=" + this.subdomain).then(res => {
      res.data.menus = res.data.menus.map(m => {
        m.orgId = org;
        return m
      });
      return res;
    });
  }

  getToc = (exhibitionId,) => {
    return Api.client.get("/content/" + exhibitionId + "/toc?sd=" + this.subdomain);
  };

  getExhibit = (exhibitionId,) => {
    return Api.client.get("/content/" + exhibitionId + "/root?sd=" + this.subdomain);
  }

  touch = (obj) => {
    return Api.client.post("/organizations/" + this.organization + "/touches", obj);
  }

  signin = (obj) => {
    return Api.client.post("/authentications", obj);
  }

  validateTotp = (obj,) => {
    return Api.client.post("/authentications/current/otp/validate", obj)
  }

  getMe = () => {
    return this.init().get("/users/me");
  }

  getCurrent = () => {
    return Api.client.get("/authentications/current?sd=" + this.subdomain);
  }

  deleteCurrent = () => {
    return Api.client.delete("/authentications/current?sd=" + this.subdomain).then((res) => {
      this.init(true);
      return res;
    });
  }

  resetPassword = (obj) => {
    return Api.client.post("/users/password_reset_request?sd=" + this.subdomain, obj)
  }
}
const api = new Api();
export default api;
